export default __webpack_public_path__ + "static/media/seed-cross.e8a696e2.png";